import { render, staticRenderFns } from "./CustomerProducts.vue?vue&type=template&id=75d16b8a"
import script from "./CustomerProducts.vue?vue&type=script&lang=js"
export * from "./CustomerProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports